<div
    class="agpr-madCoverageInsights"
    [agprLoading]="loading && !findingKeyMessages"
>
    @if (!keyMessageGroups?.length && !findingKeyMessages) {
        <div
            class="agpr-madCoverageInsights-dashboard"
        >
            <div class="agpr-madCoverageInsights-infoCard">
                <div class="agpr-madCoverageInsights-infoCard-icon">
                    <span
                        aria-hidden="true"
                        class="fa-kit-duotone fa-agpr-insights"
                    ></span>
                </div>
                <div
                    class="agpr-madCoverageInsights-infoCard-header"
                    [innerHTML]="'Reports.coverageInsight.promotion.heading' | localize "
                >
                </div>
                <div
                    class="agpr-madCoverageInsights-infoCard-text"
                    [innerHTML]="'Monitor.MAD.coverageInsights.promotion.text' | localize: {count: mentionCount} "
                >
                </div>

                @if (mentionCount >= errorMentionCount) {
                    <div
                        class="agpr-madCoverageInsights-dashboard-mentionCountInfo"
                    >
                        <agpr-message
                            [severity]="messageSeverityEnum.error"
                        >
                            {{ 'Reports.coverageInsight.mentionCountInfo.error' | localize }}
                        </agpr-message>
                    </div>
                } @else if (mentionCount >= warningMentionCount) {
                    <div
                        class="agpr-madCoverageInsights-dashboard-mentionCountInfo"
                    >
                        <agpr-message
                            [severity]="messageSeverityEnum.warning"
                        >
                            {{ 'Reports.coverageInsight.mentionCountInfo.warning' | localize }}
                        </agpr-message>
                    </div>
                }
                    <div class="agpr-madCoverageInsights-addContext-container">
                        <div class="agpr-madCoverageInsights-addContext-description">
                            {{ 'Monitor.MAD.coverageInsights.addContext.description' | localize }}
                        </div>
                        <agpr-textarea-input
                            class="agpr-madCoverageInsights-addContext-textareaInput"
                            [id]="'madCoverageInsights_addContext_textarea'"
                            placeholder="Monitor.MAD.coverageInsights.addContext.placeholder"
                            [(ngModel)]="analysisContext"
                            [rows]="5"
                            [icon]="'fa-kit-duotone fa-agpr-ai-generic'"
                        ></agpr-textarea-input>
                        <div class="agpr-madCoverageInsights-infoCard-button">
                            <agpr-button
                                label="Reports.coverageInsight.promotion.button"
                                id="drilldownMADAnalyzeCoverage"
                                (click)="analyzeCoverage($event)"
                                [style]="buttonTypes.primary"
                                [disabled]="mentionCount <= 0"
                                [tailIcon]="hasCoverageInsightsEnabled ? '' : 'fa-kit-duotone fa-agpr-upgrade'"
                            ></agpr-button>
                        </div>
                    </div>
            </div>
        </div>
    } @else {
        <div
            class="agpr-madCoverageInsights-keyMessages"
        >
            @if (findingKeyMessages) {
                <!-- placeholder loading -->
                <div
                    class="agpr-madCoverageInsights-placeholder"
                >
                    <div class="agpr-madCoverageInsights-placeholder-text">
                        {{ 'Monitor.MAD.coverageInsights.keyMessages.loadingText' | localize }}
                    </div>
                    <div class="agpr-madCoverageInsights-placeholder-topBar">
                        <div class="agpr-madCoverageInsights-placeholder-topBarLeft">
                            <div class="agpr-madCoverageInsights-placeholder-skeleton1"></div>
                        </div>
                        <div class="agpr-madCoverageInsights-placeholder-topBarRight">
                            <div class="agpr-madCoverageInsights-placeholder-skeleton2"></div>
                        </div>
                    </div>
                    <div class="agpr-madCoverageInsights-placeholder-bar">
                        <div class="agpr-madCoverageInsights-placeholder-skeleton1"></div>
                    </div>
                    <div class="agpr-madCoverageInsights-placeholder-card agpr-madCoverageInsights-placeholder-opacity8">
                        <div class="agpr-madCoverageInsights-placeholder-skeleton2"></div>
                    </div>
                    <div class="agpr-madCoverageInsights-placeholder-card agpr-madCoverageInsights-placeholder-opacity5">
                        <div class="agpr-madCoverageInsights-placeholder-skeleton1"></div>
                    </div>
                    <div class="agpr-madCoverageInsights-placeholder-card agpr-madCoverageInsights-placeholder-opacity3">
                        <div class="agpr-madCoverageInsights-placeholder-skeleton2"></div>
                    </div>
                    <div class="agpr-madCoverageInsights-placeholder-card agpr-madCoverageInsights-placeholder-opacity1">
                        <div class="agpr-madCoverageInsights-placeholder-skeleton1"></div>
                    </div>
                </div>
            } @else {
                <div class="agpr-madCoverageInsights-keyMessages-label">
                    {{ "Reports.coverageInsight.keyMessages" | localize }}
                </div>

                <agpr-scroll-panel
                    #keyMessageScrollPanel
                >
                    <div class="agpr-madCoverageInsights-keyMessages-mentionCountInfo">
                        @if (analysisContext) {
                            <div
                                class="agpr-madCoverageInsights-keyMessages-context"
                                [ngClass]="{'agpr-madCoverageInsights-keyMessages-context--bottomMargin': mentionCount > warningMentionCount}"
                            >
                                <agpr-message [severity]="messageSeverityEnum.info">
                                    @if (mentionCount <= warningMentionCount) {
                                        <div [innerHTML]="'Monitor.MAD.coverageInsights.analysisContext.mentionCountLabel' | localize: {total: mentionCount}"></div>
                                    }
                                    <span>
                                        <b>{{ 'Monitor.MAD.coverageInsights.analysisContext.label' | localize }}</b>
                                        <span>{{ analysisContext }}</span>
                                    </span>
                                </agpr-message>
                            </div>
                        }

                        @if (mentionCount > errorMentionCount) {
                            <agpr-message
                                [severity]="messageSeverityEnum.error"
                            >
                                <div [innerHTML]="'Monitor.MAD.coverageInsights.analysisContext.mentionCountLabel' | localize: {total: mentionCount}"></div>
                                {{ 'Reports.coverageInsight.mentionCountInfo.error' | localize }}
                            </agpr-message>
                        } @else if (mentionCount > warningMentionCount) {
                            <agpr-message
                                [severity]="messageSeverityEnum.warning"
                            >
                                <div [innerHTML]="'Monitor.MAD.coverageInsights.analysisContext.mentionCountLabel' | localize: {total: mentionCount}"></div>
                                {{ 'Reports.coverageInsight.mentionCountInfo.warning' | localize }}
                            </agpr-message>
                        } @else if (!analysisContext) {
                            <agpr-message
                                [severity]="messageSeverityEnum.info"
                            >
                                <div [innerHTML]="'Monitor.MAD.coverageInsights.analysisContext.mentionCountLabel' | localize: {total: mentionCount}"></div>
                            </agpr-message>
                        }
                    </div>

                    <div class="agpr-madCoverageInsights-keyMessages-cardContainer">
                        @for (keyMessageGroup of keyMessageGroups; track $index) {
                            <div
                                class="agpr-madCoverageInsights-keyMessages-card"
                                [ngClass]="{
                                    'agpr-madCoverageInsights-keyMessages-card--selected': keyMessageGroup.selected
                                }"
                                (click)="selectKeyMessage(keyMessageGroup)"
                            >
                                <div class="agpr-madCoverageInsights-keyMessages-card-content">
                                    <div class="agpr-madCoverageInsights-keyMessages-card-title">{{ keyMessageGroup.keyMessageGroupTitle }}</div>
                                    <div class="agpr-madCoverageInsights-keyMessages-card-summary">{{ keyMessageGroup.keyMessageGroupSummary }}</div>
                                </div>
                            </div>
                        }
                    </div>
                </agpr-scroll-panel>
            }
        </div>
        <div
            class="agpr-madCoverageInsights-mentions"
            [agprLoading]="loadingMentions"
        >
            @if(!findingKeyMessages) {
                <div class="agpr-madCoverageInsights-mentions-headingContainer">
                    <div class="agpr-madCoverageInsights-mentions-heading">
                        {{ "Reports.coverageInsight.mentionSamples" | localize }}
                    </div>
                    <span
                        role="img"
                        class="agpr-madCoverageInsights-tooltip fa-regular fa-circle-info"
                        [agprTooltip]="'Reports.coverageInsight.mentionSamples.tooltip' | localize"
                    ></span>
                </div>

                <div class="agpr-madCoverageInsights-mentions-toolbar">
                    <span class="agpr-madCoverageInsights-mentions-toolbar-selectToggle">
                        <agpr-checkbox
                            [id]="id + 'mentions_toolbar_selectToggle'"
                            [label]="selectedMentionCount"
                            [disabled]="!mentions?.length"
                            [binary]="true"
                            [pTooltip]="(selectedMentionCount > 0 ? 'Monitoring.result.selectNone' : 'Monitoring.result.selectAll') | localize"
                            hiddenLabel="Monitoring.result.selectAll"
                            [ngModel]="!!selectedMentionCount"
                            (ngModelChange)="toggleSelectAll()"
                        ></agpr-checkbox>
                    </span>
                    <div class="agpr-madCoverageInsights-mentions-toolbar-folderSelector">
                        <agpr-autocomplete
                            [id]="id + 'mentions_toolbar_folderSelector'"
                            labelField="name"
                            placeholder="Monitoring.folderPicker.placeholder"
                            [dropdown]="true"
                            [(ngModel)]="selectedFolder"
                            (clear)="selectedFolder = null"
                            [customOptions]="folderAutocompleteOptions"
                            [suggestions]="folderList$"
                            [clearOnBlur]="false"
                            [ariaLabel]="'Monitoring.folderPicker.tooltip'"
                            [showHiddenOption]="true"
                        ></agpr-autocomplete>
                    </div>
                    <div class="agpr-madCoverageInsights-mentions-toolbar-applyButton">
                        <agpr-button
                            [id]="id + 'mentions_toolbar_applyButton'"
                            [label]="'Monitoring.result.saveMentions' | localize"
                            [style]="buttonTypes.tertiary"
                            [disabled]="!mentions?.length || selectedMentionCount < 1 || saveInProgress"
                            (click)="saveSelectedMentions()"
                        ></agpr-button>
                    </div>
                </div>
                <agpr-scroll-panel
                    #mentionScrollPanel
                >
                    <div class="agpr-madCoverageInsights-mentions-cards">
                        <ul>
                            <li *ngFor="let mention of mentions; let i = index">
                                <agpr-coverage-insight-mention-card
                                    class="agpr-madCoverageInsights-mentionCard"
                                    [mention]="mention"
                                    (mentionSelectChange)="mentionSelectChange()"
                                    (contactClicked)="mentionCardClicked({ eventType: 'contact', mention: mention })"
                                    (outletClicked)="mentionCardClicked({ eventType: 'outlet', mention: mention })"
                                    (manageMention)="openManageMentionOrganizationDialog(mention)"
                                    (click)="mentionCardClicked({ eventType: 'mention', mention: mention })"
                                    (viewMention)="mentionCardClicked({ eventType: 'mention', mention: mention })"
                                >
                                </agpr-coverage-insight-mention-card>
                            </li>
                        </ul>
                        @if(!mentions?.length) {
                            <div class="agpr-madCoverageInsights-mentions-noContent">
                                <agpr-message
                                    [severity]="messageSeverityEnum.noContent"
                                >
                                    {{ 'Monitoring.result.noMentionsFound' | localize }}
                                </agpr-message>
                            </div>
                        }
                    </div>
                </agpr-scroll-panel>
                <div class="agpr-madCoverageInsights-mentions-actionButtons">
                    <agpr-button
                        [id]="id + 'mentions_actionButton'"
                        label="Monitor.MAD.coverageInsights.actionButton.moreInsights"
                        (click)="openDrilldown()"
                        [style]="buttonTypes.secondary"
                        [icon]="'fa-kit-duotone fa-agpr-insights'"
                    ></agpr-button>
                </div>
            }
        </div>
    }
</div>
